import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { get } from "../../utils/api";
import Footerr from "../Footerr/Footerr";
import Lottie from "lottie-react";
import { useMediaQuery } from "react-responsive";
import emailconfirm from "../../Assets/Media/LottiesJSONs/emailconfirm.json";
import emailfailed from "../../Assets/Media/LottiesJSONs/emailfailed.json";
const ConfirmEmail = () => {
  const { token } = useParams();
  const [message, setMessage] = useState("");
  const [isSuccess, setIsSuccess] = useState(true); // State to determine success or failure
  const navigate = useNavigate(); // Initialize useNavigate

  useEffect(() => {
    const confirmEmail = async () => {
      try {
        const response = await get(`/sam/doc/users/confirm/${token}`);
        setMessage(response.message);
      } catch (error) {
        setMessage(error.response?.data?.message || "Email confirmation failed");
        setIsSuccess(false); // Set to false if confirmation fails
      }
    };

    confirmEmail();
  }, [token]);

  const handleGoHome = () => {
    navigate("/Login"); // Redirect to the home page
  };

  const isMobile = useMediaQuery({
    query: "(max-width: 767px)",
  });

  return (
    <div>
      <div className="pattern-bg2 pt-[150px] flex flex-col items-center justify-center bg-gray-100">
        <div className="text-center a-padding a-container contents">
          {isSuccess ? (
            <Lottie
              animationData={emailconfirm}
              loop
              autoplay
              style={{
                width: isMobile ? "250px" : "350px",
                height: isMobile ? "250px" : "350px",
                background: "transparent",
                scale: 5,
                margin: "auto",
              }}
            />
          ) : (
            <Lottie
              animationData={emailfailed}
              loop
              autoplay
              style={{
                width: isMobile ? "250px" : "350px",
                height: isMobile ? "250px" : "350px",
                background: "transparent",
                scale: 5,
                margin: "auto",
              }}
            />
          )}
          <h1 className="text-3xl font-bold mb-2">{message}</h1>
          {isSuccess ? (
            <p className="text-lg text-gray-700 mb-4">
              Thank you for confirming your email address.
            </p>
          ) : (
            <p className="text-lg text-gray-700 mb-4">
              Please try confirming your email again or contact support.
            </p>
          )}
          <button
            onClick={handleGoHome}
            className="join-btn custom-btn main-button  !mb-[3rem] !rounded-[4px]"
          >
            Go to Login
          </button>
        </div>
      </div>
      <Footerr />
    </div>
  );
};

export default ConfirmEmail;
